import type { ForwardedRef, PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import type { IconButtonProps } from '@mui/material/IconButton';
import IconButton from '@mui/material/IconButton';

import CircularProgress from './circular-progress';
import AtpSkeleton from './skeleton';

type TRef = HTMLButtonElement | null;

interface IProps extends IconButtonProps {
  loading?: boolean;
  preload?: boolean;
  width?: number | string;
  height?: number | string;
}

const TempIconButton = (
  { loading, children, preload, width = 48, height = 48, ...rest }: PropsWithChildren<IProps>,
  ref: ForwardedRef<TRef>
) => {
  const { className, size = 'large', ...remaining } = rest as IconButtonProps;
  return preload ? (
    <AtpSkeleton width={width} height={height} variant="circular" className={className} />
  ) : (
    <IconButton ref={ref} className={className} {...remaining} size={size}>
      {children}
      {loading && <CircularProgress size={24} className="absolute left-1/2 top-1/2 -ml-3 -mt-3" />}
    </IconButton>
  );
};

const AtpIconButton = forwardRef<TRef, PropsWithChildren<IProps>>(TempIconButton);
export default AtpIconButton;
